import styled from "styled-components";
import { BORDER_RADIUS } from "../../constants/design/spacing";
import { COLORS, LAYER_COLORS } from "../../constants/design/colors";

export const FillMeterWrapper = styled.div<{textColor?: string; layoutReversed?: boolean}>`
  display: flex;
  flex-direction: ${({ layoutReversed }) => (layoutReversed ? "row-reverse" : "row")};
  align-items: center;
  color: ${({ textColor }) => textColor || COLORS.blue.one};
`;

// percent is a number between 0-100
export const Bar = styled.div`
  background-color: ${LAYER_COLORS.three};
  width: 24px;
  height: 2px;
  border-radius: ${BORDER_RADIUS.full}px;
  overflow: hidden;
`;

export const FillPercentage = styled.div`

`;

export const BarInner = styled.div.attrs<{
  percent?: number;
  fillColor?: string;
}>(({ percent, fillColor }) => ({
  style: {
    background: fillColor || COLORS.blue.one,
    // An unknown percentage draws NO fill. Interpolating it produced
    // `width: NaN%` — invalid CSS the browser discards, leaving the bar at
    // whatever width it last had, which reads as a real measurement.
    width: percent === undefined ? 0 : `${percent}%`,
  },
}))<{
  percent?: number;
  fillColor?: string;
}>`
  height: 100%;
  transition: all 0.2s ease-in-out;
`;
